import { useWfAuthStore } from 'src/api/wf/stores/WfAuthStore';
import WF_Header from '../common/header/WfHeader';
import WF_Menu from '../common/menu/WF_Menu';
import { useWfTyphoonStore } from 'src/api/wf/stores/WfTyphoonStore';
import { useTranslation } from 'react-i18next';
import { isPastDate } from 'src/common/isPastDate/isPastDate';

type WF_MainProps = {
  component: React.ReactNode;
  alertOpened?: React.ReactNode;
  isSystemLaunch?: boolean;
};

const WF_Main = ({ component, isSystemLaunch }: WF_MainProps) => {
  const { t } = useTranslation();
  const { authenticated } = useWfAuthStore();
  const { currentTyphoon } = useWfTyphoonStore();

  const displayNoDisasterScreen =
    !currentTyphoon ||
    !currentTyphoon?.launchDateTime ||
    !isPastDate(currentTyphoon?.startDateTime);

  return (
    <div className="flex min-h-screen flex-col">
      {authenticated && <WF_Header />}
      <div className="flex flex-1">
        <nav className="w-64 shrink-0 bg-gray-50 p-2">
          <WF_Menu typhoonInfo generalMenu />
        </nav>
        {displayNoDisasterScreen && !isSystemLaunch ? (
          <main className="flex flex-1 items-center justify-center">
            <div className="text-center">
              <h2 className="text-2xl font-bold">{t('wf.systemLaunch.alert.noDisaster')}</h2>
            </div>
          </main>
        ) : (
          <main className="min-w-0 flex-1 p-2">{component}</main>
        )}
      </div>
    </div>
  );
};

export default WF_Main;
